import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskVm } from '../osk-vm.model';
import { IOskActivationIm } from '../osk-activation-im.model';
@Injectable({ providedIn: 'root' })
export class OskActivationService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OskActivation`;
  }
  post(oskActivationIm: IOskActivationIm): Observable<IOskVm> {
    const headers = this.createHeaders();
    return this.http.post<IOskVm>(this.baseUrl, oskActivationIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
